module.exports = __webpack_public_path__ + "img/cocina.e506c2dd.svg";